import { Flex } from "@similarweb/ui-components/foundations";

import { MeVsCompetitorsChartContainer } from "./charts/me-vs-competitors-chart";
import { MyChannelsOverview } from "./charts/my-channels-overview";
import { ShareOfChannelTrafficPdf } from "./tables/share-of-channel-traffic";
import { ShareOfWebsiteTrafficPdf } from "./tables/share-of-website-traffic";

export const ChannelsTabPdf = () => (
    <>
        <Flex
            gap="24px"
            width="100%"
            className="pageBreakBefore"
            margin="0 0 24px 0"
        >
            <MyChannelsOverview />
            <MeVsCompetitorsChartContainer />
        </Flex>
        <ShareOfWebsiteTrafficPdf />
        <ShareOfChannelTrafficPdf />
    </>
);
